module.exports = __webpack_public_path__ + "img/areas.3b95c6c3.gif";